import * as yup from "yup";

export type FormValues = {
  amount?: number | null;
  payerFullName?: string;
  orderNumber?: string;
};

export const getValidationSchema = (
  isAmountRequired: boolean,
  requestPayerFullName: boolean,
  requestOrderNumber: boolean,
) =>
  yup.object({
    amount: yup
      .number()
      .transform((value) => (isNaN(value) ? null : value))
      .nullable()
      .when([], {
        is: () => isAmountRequired,
        then: (schema) =>
          schema
            .moreThan(0, "Вкажіть 'Суму до сплати'")
            .required("Вкажіть 'Суму до сплати'"),
        otherwise: (schema) => schema.notRequired(),
      }),

    payerFullName: yup.string().when([], {
      is: () => requestPayerFullName,
      then: (schema) =>
        schema
          .trim()
          .max(40, "'Ім'я та прізвище' має містити менше ніж 40 символів")
          .required("Вкажіть 'Ім'я та прізвище'"),
      otherwise: (schema) => schema.optional(),
    }),
    orderNumber: yup.string().when([], {
      is: () => requestOrderNumber,
      then: (schema) =>
        schema
          .trim()
          .max(15, "'Номер замовлення' має містити менше ніж 15 символів")
          .required("Вкажіть 'Номер замовлення'"),
      otherwise: (schema) => schema.optional(),
    }),
  });
